import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { LocalStorageAdapter } from '../../../lib/adapters/local-storage';

export const adapter = new LocalStorageAdapter('config');

export type SetValueAction = PayloadAction<{
  key: keyof AppConfigState;
  value: unknown;
}>;

// Define a type for the slice state
type AppConfigState = typeof defaultInitialState;

// Define the initial state using that type
const defaultInitialState = {
  darkMode: false,
  locale: 'en-GB',
};

const getInitialState = () => {
  let initial: AppConfigState = { ...defaultInitialState };

  try {
    const keys = Object.keys(initial) as (keyof AppConfigState)[];

    keys.forEach((key) => {
      const value = adapter.getItem(key);

      if (value !== null) {
        initial = { ...initial, [key]: value };
      }
    });
  } catch {}

  return initial;
};

export const appConfigSlice = createSlice({
  name: 'appConfig',

  initialState: getInitialState(),

  reducers: {
    setValue(state, action: SetValueAction) {
      const { key, value } = action.payload;
      // @ts-expect-error not strictly typed
      state[key] = value;
    },

    reset(state: AppConfigState) {
      return { ...defaultInitialState };
    },
  },
});

export const { setValue } = appConfigSlice.actions;

export default appConfigSlice.reducer;
